import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20Korean%20manhwa%20style%20illustration%20with%20flowing%20ink%20and%20brushstroke%20effects%2C%20dark%20elegant%20atmosphere%20with%20crimson%20and%20gold%20accents%2C%20motion%20lines%20and%20dynamic%20composition%2C%20comic%20panel%20aesthetic%2C%20dramatic%20lighting%20with%20spotlight%20effect%2C%20professional%20hero%20banner%20design&width=1920&height=800&seq=hero-bg-comics&orientation=landscape"
          alt="韩漫漫画网站 - 您的韩漫阅读天堂"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <p className="text-primary-300 text-sm md:text-base font-label tracking-widest mb-3 animate-[fadeInUp_0.6s_ease-out]">
          韩国漫画大全 · 热门推荐 · 排行榜
        </p>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 mb-4 leading-tight animate-[fadeInUp_0.8s_ease-out]">
          发现最精彩的<span className="text-primary-400">韩国漫画</span>
        </h1>
        <p className="text-foreground-200 text-sm md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed animate-[fadeInUp_1s_ease-out]">
          海量韩漫资源，免费下拉式阅读，高清画质无广告。<br className="hidden sm:block" />
          热门连载每日更新，经典完结一网打尽，享受纯粹阅读乐趣。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 animate-[fadeInUp_1.2s_ease-out]">
          <Link
            to="/category/fantasy-adventure"
            className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 rounded-full font-label text-sm font-medium transition-all cursor-pointer whitespace-nowrap text-center"
          >
            <i className="ri-compass-3-line mr-2"></i>开始探索
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3 bg-background-50/20 hover:bg-background-50/30 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-label text-sm transition-all cursor-pointer whitespace-nowrap text-center"
          >
            <i className="ri-information-line mr-2"></i>了解更多
          </Link>
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>
  );
}